module.exports = __webpack_public_path__ + "img/tree_10004.9b59d9d0.png";